import React from "react";
import ReduxSelect from "../../../core/form/select/ReduxSelect";
import {useDispatch, useSelector} from 'react-redux';
import {fetchAllFacilityTypes} from "../../../actions/facilityTypes";

let FacilityTypeSelect = (props) => {

    let dispatch = useDispatch();

    let {name, label} = props

    let {allIds} = useSelector(state => state.facilityType)

    React.useEffect(() => {
        dispatch(fetchAllFacilityTypes())
    }, [dispatch])

    return <ReduxSelect
        name={name}
        label={label}
        placeholder='Wybierz kategorię obiektu'
        stateKey='facilityType'
        data={allIds}
        autocomplete={false}
        {...props}
    />

}

export default FacilityTypeSelect;
